<template>
  <div class="add-connector">
    <el-dialog
      title="创建连接器"
      :visible.sync="visible"
      v-if="visible"
     width= "650px"
      class="dialog"
      @open="open"
    >
      <div class="connector-body">
        <el-form
          class="connectorRef"
          ref="connectorRef"
          :model="connectorForm"
          :rules="connectorRules"
        >
          <el-form-item label="连接器名称" prop="connectorName">
            <el-input
              v-model="connectorForm.connectorName"
              style="width: 600px"
              placeholder="请输入连接器名称"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="接口域名">
            <el-switch v-model="InterfaceActive" active-text="设为模板变量">
            </el-switch>
            <el-input
              v-model="connectorForm.InterfaceName"
              style="width: 600px"
              placeholder="https://example.com"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="鉴权方式" prop="radio">
            <el-radio-group v-model="connectorForm.radio" style="width: 600px">
              <el-radio label="APISecret" v-model="connectorForm.radio"
                >APISecret</el-radio
              >
              <el-radio label="BasicAuth" v-model="connectorForm.radio"
                >Basic Auth</el-radio
              >
            </el-radio-group>
          </el-form-item> -->

          <!-- <el-form-item
            label="APISecret"
            v-if="connectorForm.radio == 'APISecret'"
          >
            <el-switch
              v-model="connectorForm.APISecret"
              active-text="设为模板变量"
            >
            </el-switch>
            <el-input
              v-model="connectorForm.APISecretName"
              style="width: 600px"
              placeholder="请输入"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item
            label="账户信息"
            v-if="connectorForm.radio === 'BasicAuth'"
            prop="AccountInformation"
          >
            <el-switch
              v-model="connectorForm.APISecret"
              active-text="设为模板变量"
            >
            </el-switch>
            <el-input
              v-model="connectorForm.username"
              style="width: 600px"
              placeholder="username"
            >
              <template slot="prepend">用户名</template>
            </el-input>
            <el-input
              :key="passwordType"
              ref="password"
              v-model="connectorForm.password"
              :type="passwordType ? 'password' : 'text'"
              style="width: 600px; margin-top: 8px"
              placeholder="password"
            >
              <template slot="prepend">密码&emsp;</template>
            </el-input>
            <span class="show-pwd" @click="changePawwordType">
              <i :class="passwordType ? 'el-icon-lock' : 'el-icon-view'"></i>
            </span>
          </el-form-item> -->
          <el-form-item label="关联应用">
            <el-select
              v-model="connectorForm.appId"
              placeholder="请选择关联应用"
              style="width: 600px"
            >
              <el-option
                v-for="item in listingList"
                :key="item.id"
                :label="item.description"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="功能介绍">
            <el-input
              type="textarea"
              v-model="connectorForm.connectorComment"
              style="width: 600px"
              placeholder="暂无描述"
            ></el-input>
          </el-form-item>
         
          <el-form-item label="图标" prop="connectorLogo"> </el-form-item>
          <div class="img-upload">
            <image-upload
              ref="uploadImg"
              :multiple="false"
              :imageUrl="connectorForm.connectorLogo"
              @success="connectorForm.connectorLogo = $event"
            />
            <div class="text">请上传方形图片，尺寸大于 200*200px</div>
          </div>
        </el-form>
      </div>
      <div class="footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="onSave">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import connector from "@/apis/connector";
import ImageUpload from "./image-upload";

export default {
  name: "add-connector",
  props: {
    data:{
      type:Array
    }
  },
  components: { ImageUpload },
  data() {
    return {
      listingList: [],
      visible: false,
      value1: false,
      InterfaceActive: false,
      APISecret: true,
      imageUrl: "",
      passwordType: true,
      connectorForm: {
        connectorName: "",
        InterfaceName: "",
        Authentication: "",
        APISecretName: "",
        radio: "APISecret",
        appId: "",
        connectorComment: "",
        AccountInformation: "",
        username: "",
        password: "",
        connectorLogo: "",
      },
      connectorRules: {
        connectorName: [
          { required: true, message: "请输入连接器名称", trigger: "change" },
        ],
         connectorLogo: [
          { required: true, message: "图片项为必填项", trigger: "change" },
        ],
        // radio: [{ required: true, message: "请输入鉴权方式", trigger: "blue" }],
        // APISecretName: [
        //   { required: true, message: "请输入APISecret", trigger: "change" },
        // ],

        // AccountInformation: [{ required: true, trigger: "blue" }],
        // username: [
        //   { required: true, message: "请输入用户名", trigger: "blue" },
        // ],
        // password: [{ required: true, message: "请输入密码", trigger: "blue" }],
      },
    };
  },
  methods: {
    open() {
      this.visible = true;
   
    },
    onSave() {
      this.$refs.connectorRef.validate(async (isOk) => {
        if (!isOk) return;
        const res = await connector.assConnnect(this.connectorForm);
        this.$message.success(`添加成功！`);
        this.visible = false;
        this.$emit('success')
        this.connectorForm={
            connectorName:"",
            connectorComment: "",
            connectorLogo: "",
        }
      });
    },
    onClose() {
      this.visible = false;
       this.connectorForm={
            connectorName:"",
            connectorComment: "",
            connectorLogo: "",
        }
    },

    changePawwordType() {
      this.passwordType = !this.passwordType;
    },
    updateSuccess() {
      this.connectorForm.connectorLogo = $event;
    },
    uploadImgSuccess(newLogo) {
      this.connectorForm.connectorLogo = newLogo;
    },
  },
};
</script>
<style scoped lang="scss">
.add-connector {
  width: 636px;
  //
}

.connector-body {
  display: flex;
  flex-wrap: wrap;
  height: 500px;
  // padding-top: 15px;
  box-sizing: border-box;
  padding: 15px 20px 0 20px;
  border-top: 1px solid #e2e2e2;
  border-bottom: 1px solid #e2e2e2;
  overflow-y: auto;
}
.connectorRef {
  position: relative;
  // padding: 0 20px 0  20px;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 72px;
  font-size: 16px;
  cursor: pointer;
}
::v-deep .el-dialog__body {
  padding: 0;
}
.img-upload {
  display: flex;
  .text {
    width: 110px;
    height: 38px;
    font-size: 10px;
    margin-left: 12px;
    color: #a2a3a5;
  }
}

.footer {
  padding: 10px 10px 10px 0;
  text-align: right;
}
</style>
